import { components } from 'src/infrastructure/rest-api/generated';
import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export type NotificationData = components['schemas']['NotificationModel'][];

export const useNotificationsQuery = () => {
    const response = useApiQuery('/api/notifications', 'get');
    return response;
};
